/* This is used to manage each popup state for self-implemented/toggle elements
 * and make sure only one of them is displayed in UI.
 * Those elements with embeded popup function are not needed, because they are already managed by theirselves, such as ngbDropdown.
 * Usage:
 * 1. import PopupManager from './popup-manager';
 * 2. const popupManager = new PopupManager();
 * 3. popupManager.open(PopupType.FILTER_FIELD);
 * 4. popupManager.closeAllcloseAll();
 * 5. popupManager.toggle(PopupType.DATE_PICKER);
 * 6. popupManager.getCurrent();
 */
export enum PopupType {
  NONE = 'none',
  FILTER_FIELD = 'filterField',
  DATE_PICKER = 'datePicker',
  CUSTOMIZE = 'customize'
}

export class PopupManager {
  private activePopup: PopupType = PopupType.NONE;

  // Check if a specific popup is open
  isOpen(type: PopupType): boolean {
    return this.activePopup === type;
  }

  // Open a specific popup (closes others automatically)
  open(type: PopupType): void {
    this.activePopup = type;
  }

  // Close all popups
  closeAll(): void {
    this.activePopup = PopupType.NONE;
  }

  // Toggle a specific popup
  toggle(type: PopupType): void {
    if (this.activePopup === type) {
      this.closeAll();
    } else {
      this.open(type);
    }
  }

  // Get current active popup
  getCurrent(): PopupType {
    return this.activePopup;
  }
}
